/**
 * vs-reveal.js — IntersectionObserver voor fade-in animatie.
 * Voegt 'vs-reveal--visible' toe aan elementen met class 'vs-reveal'
 * zodra ze in beeld komen. Seed-stijl progressive disclosure.
 */
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('vs-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  // Observe bestaande elementen
  document.querySelectorAll('.vs-reveal').forEach((el) => observer.observe(el));

  // Observe dynamisch toegevoegde elementen
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.classList?.contains('vs-reveal')) observer.observe(node);
          node.querySelectorAll?.('.vs-reveal').forEach((el) => observer.observe(el));
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}
